import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";

const BrandUrgencias = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        width: "100%",
        padding: "18px 0",
        // marginTop: "20px",
        backgroundColor: "#d6001c",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: {xs:"360px", sm:"560px", md:"768px", lg:"840px"},
          height: "100%",
          paddingLeft: 0,
        }}
      >
        <Stack direction="row" spacing={2} width="100%">
          <Typography variant="h5" sx={{width:{xs:"25%", sm:"10%"}, alignContent:"center"}}>
            <CampaignIcon sx={{ fontSize: "55px", color: "white" }} />
          </Typography>
          <Typography variant="h5" sx={{ 
            width:{xs:"75%", sm:"35%"},
            color:"white",
            fontWeight:"700",
            display:"flex",
            alignItems:"center",
            fontSize:{xs:"20px", sm:"24px", md:"28px"},
            paddingRight: !isMobile ? "15px" : undefined,
            borderRight: !isMobile ? "3px solid #fff" : undefined,
          }}>
            ¡Servicio de urgencias médicas las 24 horas!
          </Typography>
          {!isMobile ? (
            <Typography sx={{
              width:{sm:"55%"},
              alignItems:"center",
              display:"flex",
              color:"white",
              fontSize:{xs:"20px", sm:"24px", md:"28px"}
            }}>
              Atención médica oportuna, profesional y ética las 24 horas del
              día, los 365 días del año.
            </Typography>
          ) : undefined}
        </Stack>
        <Button
          component="a"
          href= "tel:3112119470" 
          sx={{
            width: "60%",
            margin: "15px 0px 0px 0px",
            padding:"10px",
            fontSize: {xs:"14px", sm:"16px"},
            lineHeight: 1.334,
            bgcolor: "#ffffff",
            color: "#D6001C",
            transition: "transform 0.3s ease-in-out", 
            borderRadius: "8px",
            textAlign: "center",
            fontWeight: 700,
            '&:hover': {
              bgcolor: "#ffda00",
              color:"#AB001C",
              transform: "scale(1.1)",
              transition: "1s,transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
            }
          }}
        >
          Telefono: 311-211-94-70
        </Button>
      </Container>
    </Box>
  );
};

export default BrandUrgencias;
